<template>
  <el-dialog :title="$t('newApp.ADList.na')" :visible.sync="dialogVisible" :append-to-body="true" width="50%"
    class="addLocationDialog" @close="dialogCloseHandle">
    <el-form class="common_form" label-position="left" ref="addLocationForm" :rules="rules" label-width="150px"
      :model="formData">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('general.cp')" prop="consignee">
            <el-input v-model="formData.consignee" :placeholder="$t('general.pec')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('newApp.ADList.Mp')" prop="consigneePhone">
            <el-input v-model="formData.consigneePhone" :placeholder="$t('general.pec')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('newApp.ADList.At')" prop="countryType">
            <el-radio-group v-model="formData.countryType" @change="countryTypeChange">
              <el-radio label="0">{{ $t('newApp.ADList.Domestic') }}</el-radio>
              <el-radio label="1">{{ $t('newApp.ADList.International') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <template v-if="formData.countryType === '0'">
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.Province')" prop="provinceCode">
              <el-select v-model="formData.provinceCode" :placeholder="$t('general.ps')" @change="provinceChange">
                <el-option v-for="(item, index) in provinceList" :key="index" :label="item.regionName"
                  :value="item.regionCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.City')" prop="cityCode">
              <el-select v-model="formData.cityCode" :placeholder="$t('general.ps')" @visible-change="cityVisibleChange"
                @change="cityChange">
                <el-option v-for="(item, index) in cityList" :key="index" :label="item.regionName"
                  :value="item.regionCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.DC')" prop="countyCode">
              <el-select v-model="formData.countyCode" :placeholder="$t('general.ps')"
                @visible-change="countyVisibleChange" @change="countyChange">
                <el-option v-for="(item, index) in countyList" :key="index" :label="item.regionName"
                  :value="item.regionCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.St')" prop="streetCode" v-show="streetShow" :required="streetShow">
              <el-select v-model="formData.streetCode" :placeholder="$t('general.ps')"
                @visible-change="streetVisibleChange">
                <el-option v-for="(item, index) in streetList" :key="index" :label="item.regionName"
                  :value="item.regionCode" />
              </el-select>
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="12" v-else :key="clickIndex">
          <el-form-item :label="$t('newApp.ADList.Country')" prop="country">
            <el-select v-model="formData.country" filterable remote :remote-method="remoteMethod"
              :placeholder="$t('newApp.ADList.Psacou')">
              <el-option v-for="(item, index) in overseasList" :key="index" :label="item.fieldValue"
                :value="item.fieldValue" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('newApp.ADList.Da')" prop="detailedAddress">
            <el-input type="textarea" v-model="formData.detailedAddress" maxlength="200" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('newApp.ADList.Sad')">
            <el-checkbox-group v-model="formData.isDefault">
              <el-checkbox :label="1">{{ null }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" @click="submitHandlen">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { arrayQuery } from '@/utils/utils';
import { commonServer } from '@/API/home';
import { locationManagementApi } from '../../service';

export default {
  data() {
    let phoneNumberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('newApp.ADList.Peypn')));
      } else if (!/^[0-9]{7,}$/.test(value)) {
        callback(new Error(this.$t('newApp.BasicInfo.pnfiw')));
      } else {
        callback();
      }
    };
    let streetMessage = (rule, value, callback) => {
      if (!value && this.streetShow) {
        callback(new Error(this.$t('newApp.ADList.Psas')));
      } else {
        callback();
      }
    };
    return {
      rules: {
        consignee: [
          { required: true, message: this.$t('newApp.ADList.Peacp'), trigger: 'blur' }
        ],
        consigneePhone: [
          { required: true, validator: phoneNumberValidator, trigger: 'blur' }
        ],
        countryType: [
          { required: true, message: this.$t('newApp.ADList.Peacp'), trigger: 'change' }
        ],
        provinceCode: [
          { required: true, message: this.$t('newApp.ADList.Psap'), trigger: 'change' }
        ],
        cityCode: [
          { required: true, message: this.$t('newApp.ADList.Psaci'), trigger: 'change' }
        ],
        countyCode: [
          { required: true, message: this.$t('newApp.ADList.Psaco'), trigger: 'change' }
        ],
        country: [
          { required: true, message: this.$t('newApp.ADList.Psacou'), trigger: 'change' }
        ],
        streetCode: [{ validator: streetMessage, trigger: 'change' }],
        detailedAddress: [
          { required: true, message: this.$t('newApp.ADList.Pefa'), trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      formData: {
        isDefault: [
        ],
        countryType: '0'
      },
      provinceList: [],
      cityList: [],
      countyList: [],
      streetList: [],
      overseasList: [],
      streetShow: true,
      clickIndex: null
    };
  },
  props: {
    preventCloseFlag: {
      type: Boolean,
      default: false
    },
    addLocationShow: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addLocationShow(val) {
      if (val) {
        if (this.rowData.id) {
          this.formData = this.rowData;
          this.overseasList = [
            { fieldValue: this.rowData.country }
          ];
          this.$set(this.formData, 'isDefault', [this.rowData.isDefault]);
          this.getAddressList(this.formData.provinceCode).then(data => {
            this.cityList = data;
          });
          this.getAddressList(this.formData.cityCode).then(data => {
            this.countyList = data;
          });
          this.streetShow = true;
          if (this.formData.street && this.formData.streetCode) {
            this.getAddressList(this.formData.countyCode).then(data => {
              this.streetList = data;
            });
          } else {
            this.streetShow = false;
          }
          if (this.rowData.countryType) {
            this.$set(this.formData, 'countryType', '1');
          } else {
            this.$set(this.formData, 'countryType', '0');
          }
        } else {
          this.$set(this.formData, 'countryType', '0');
        }
        this.getAddressList().then(data => {
          this.provinceList = data;
        });
      } else {
        this.formData = {
          isDefault: []
        };
        this.$nextTick(() => {
          this.$refs.addLocationForm.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        locationManagementApi.getOverseasAddress(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.overseasList = res.data;
            } else {
              this.overseasList = [];
            }
          }
        });
      } else {
        this.overseasList = [];
      }
    },
    provinceChange() {
      this.$set(this.formData, 'cityCode', '');
      this.$set(this.formData, 'countyCode', '');
      this.$set(this.formData, 'streetCode', '');
      this.cityList = [];
      this.countyList = [];
      this.streetList = [];
      this.streetShow = true;
      this.$nextTick(() => {
        this.$refs.addLocationForm.clearValidate(['cityCode', 'countyCode', 'streetCode']);
      });
      // 获取城市列表
      this.getAddressList(this.formData.provinceCode).then(data => {
        this.cityList = data;
      });
    },
    cityChange() {
      this.$set(this.formData, 'countyCode', '');
      this.$set(this.formData, 'streetCode', '');
      this.countyList = [];
      this.streetList = [];
      this.streetShow = true;
      this.$nextTick(() => {
        this.$refs.addLocationForm.clearValidate(['countyCode', 'streetCode']);
      });
      // 获取区县列表
      this.getAddressList(this.formData.cityCode).then(data => {
        this.countyList = data;
      });
    },
    countyChange(code) {
      let countyObj = arrayQuery(code, this.countyList, 'regionCode');
      this.streetShow = !countyObj.leafNode;
      this.$set(this.formData, 'streetCode', '');
      this.$set(this.formData, 'street', '');
      this.streetList = [];
      this.$nextTick(() => {
        this.$refs.addLocationForm.clearValidate(['streetCode']);
      });
      // 获取街道数据
      this.getAddressList(code).then(data => {
        this.streetList = data;
      });
    },
    cityVisibleChange(flag) {
      if (flag && !this.formData.provinceCode) {
        this.$message.error(this.$t('newApp.ADList.Psap'));
      }
    },
    countyVisibleChange(flag) {
      if (flag && !this.formData.cityCode) {
        this.$message.error(this.$t('newApp.ADList.Psaci'));
      }
    },
    streetVisibleChange(flag) {
      if (flag && !this.formData.countyCode) {
        this.$message.error(this.$t('newApp.ADList.Psaco'));
      }
    },
    // 地址类型事件
    countryTypeChange(e) {
      this.clickIndex = new Date().getTime();
    },
    getAddressList(parentCode) {
      return new Promise((resolve, reject) => {
        let params = '';
        if (parentCode) params = '/' + parentCode;
        commonServer.getAddressList(params).then(res => {
          if (res.status === '200') {
            resolve(res.data);
          }
        });
      });
    },
    submitHandlen() {
      const { consignee, consigneePhone, detailedAddress, countryType, provinceCode, cityCode, countyCode, country } = this.formData;
      this.$refs['addLocationForm'].validate(valid => {
        if (valid) {
          let params = {
            consignee,
            consigneePhone,
            detailedAddress,
            countryType,
            isDefault:
              this.formData.isDefault &&
                this.formData.isDefault.length > 0 &&
                this.formData.isDefault[0]
                ? 1
                : 0
          };
          if (countryType === '0') {
            params.provinceCode = provinceCode;
            params.province = arrayQuery(
              this.formData.provinceCode,
              this.provinceList,
              'regionCode'
            ).regionName;
            params.cityCode = cityCode;
            params.city = arrayQuery(
              this.formData.cityCode,
              this.cityList,
              'regionCode'
            ).regionName;
            params.countyCode = countyCode;
            params.county = arrayQuery(
              this.formData.countyCode,
              this.countyList,
              'regionCode'
            ).regionName;
            if (this.streetShow) {
              params.streetCode = this.formData.streetCode;
              params.street = arrayQuery(
                this.formData.streetCode,
                this.streetList,
                'regionCode'
              ).regionName;
            }
          } else {
            params.country = country;
          }
          if (this.formData.id) {
            params.id = this.formData.id;
            locationManagementApi.editAddress(params).then(res => {
              if (res.status === '200') {
                this.overseasList = [];
                this.$message.success(this.$t('general.EditSucc'));
                this.$emit('submitSuccess', params);
              }
            });
          } else {
            locationManagementApi.addAddress(params).then(res => {
              if (res.status === '200') {
                this.overseasList = [];
                this.$message.success(this.$t('general.AddSucc'));
                this.$emit('submitSuccess', params);
              }
            });
          }
        }
      });
    },
    dialogCloseHandle() {
      this.overseasList = [];
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>

</style>
